import { ISelectOption } from '../../web/components/DeprecatedSelect';

/**
 * Gets time options
 * @source Original location: UiUtils.ts.backup line 1946
 */
export const getTimeOptions = (idLabel: string, increments: number, startTime?: number, endTime?: number) => {
	const options: ISelectOption<number>[] = [];
	let block = 0;
	while (block < 24 * 60 - 1) {
		if (startTime && startTime > block) {
			block += increments;
			continue;
		}
		if (endTime && block > endTime) {
			block += increments;
			continue;
		}

		const hour =
			block === 0 || Math.floor(block / 60) === 0 || Math.floor(block / 60) - 12 === 0 // if is 00:00 (12am) or earlier than 01:00 or 12:00 (noon), set hour to 12
				? 12
				: block / 60 < 12 // test if is in the AM
					? Math.floor(block / 60) // number of minutes / 60 (rounded down to whole number) to get AM hours
					: Math.floor(block / 60) - 12; // number of minutes / 60 (rouded down to whole number) - 12 to get PM hours
		const minutes = block === 0 || block % 60 === 0 ? '00' : block % 60; // remainder of (number of minutes / 60) will be the minutes.

		const timeLabel = `${hour}:${minutes} ${block === 0 || Math.floor(block / 60) < 12 ? 'AM' : 'PM'}`;
		const timeId = `time-option-${idLabel}-${hour}-${minutes}-${
			block === 0 || Math.floor(block / 60) < 12 ? 'am' : 'pm'
		}`;

		options.push({
			dataContext: block,
			id: timeId,
			text: timeLabel,
		});

		block += increments;
	}

	return options;
};
